module.exports = __webpack_public_path__ + "img/tech_image_13_1.dfa9ecb5.jpg";